define('views/modules/calendar/favorite/lists/favorite-list-item',[
    // Libs
    'underscore', 'backbone', 'mustache', 'bootbox', 'utils', 'toastr',
    'services/i18n',
    // views
    'views/parts/media-info-box',
], function(
    // Libs
    _, Backbone, Mustache, Bootbox, U, Toastr,
    // services
    i18n,
    // views
    VMediaInfoBox
) {

    var VFavoriteListItem = Backbone.View.extend({
        initialize: function(opt) {
            this.options = opt || {};

            this.selected = this.options.selected;

            this.view = {
                infobox: new VMediaInfoBox({
                    title: 'name',
                    icon: 'sl-icon-star',
                    photo: false,
                    model: this.model,
                    context: this,
                    onClick: this.onClick,
                    menu: {
                        init: this.onMenuInit,
                        onClick: this.onMenuAction,
                    }
                }),
            };

            this.listenTo(this.model, {
                // 'change': this.onModelChange,
                'active': this.setActive,
                'remove': this.remove
            });

        },
        render: function(hiddenDelay) {
            if (hiddenDelay > 0) {
                this.hide();
                _.delay(this.show.bind(this), hiddenDelay);
            }

            this.assign(this.view.infobox, this.$el);

            this.setActive(this.model.is(this.selected));

            return this;
        },

        setActive: function(val) {
            this.view.infobox.setActive(val);
        },

        hide: function() {
            this.$el.addClass("transparent");
        },

        show: function() {
            this.$el.removeClass("transparent");
        },

        ////////////
        // events //
        ////////////

        onClick: function(e) {
            this.model.trigger("favorite:select", this, this.model);
        },

        onMenuInit: function() {
            return new Backbone.Collection([
                { caption: 'Use', icon: "sl-icon-check", callback: this.onUse },
                { caption: 'Edit', icon: "sl-icon-note", callback: this.onEdit },
                { caption: 'Delete', icon: "sl-icon-trash", callback: this.onDeleteClicked }
            ]);
        },

        onMenuAction: function(e) {
            e.preventDefault();
        },

        onUse: function() {
            //START: Temporary patch (Bug Cardio Exercices)
            if (this.model.get('type') === 'animated-session') {
                var sessionContainCardioExercice = false;
                for (var i = 0; i < this.model.get("data").exercises.length; i++) {
                    if (this.model.get("data").exercises[0].type === "cardio") {
                      sessionContainCardioExercice = true;
                      break;
                    }
                }
                if (sessionContainCardioExercice) {
                  Toastr.warning(
                      i18n.t("Cardio favorite can't be added for this moment"),
                      "", { // These options should be set globally.
                          positionClass: "toast-top-center", // Default = toast-top-right
                          newestOnTop: false, // Default = true
                          showMethod: "slideDown",    // Default = fadeIn
                          tapToDismiss: true,  // Default = false
                          timeOut: 5000,
                          hideMethod: "fadeOut",
                          hideDuration: 750,
                          closeButton: true
                      });
                    return;
                }
                //END: Temporary patch (Bug Cardio Exercices)
            }
            this.model.trigger('favorite:apply', this.model);
        },

        onEdit: function(e) {
            this.model.trigger('favorite:edit', this.model, this);
        },

        onDeleteClicked: function() {
            Bootbox.confirm({
                title: i18n.t('calendar:Delete favorite'),
                message: i18n.t('messages:message-delete-favorite'),
                callback: this.onDelete,
                context: this,
            });
        },

        onDelete: function(result) {
            if (result) {
                this.model.destroy();
            }
        },

    });

    return VFavoriteListItem;

});

